export enum ORGANIZATION_TYPES {
	school = 'school',
	organization = 'organization',
}
